exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-widget=AemCspsMillionChild] .date-picker-control,\n[widget=AemCspsMillionChild] .date-picker-control {\n  width: 212px;\n  margin: 0 auto;\n  display: inline-block;\n}\n\n@media all and (min-width: 768px) {\n  [data-widget=AemCspsMillionChild] .inlet-wrapp .csas-calc-controls-label.csas-calc-controls-label-fixed-large,\n  [widget=AemCspsMillionChild] .inlet-wrapp .csas-calc-controls-label.csas-calc-controls-label-fixed-large {\n    width: 350px;\n  }\n }\n\n @media all and (max-width: 991px) {\n  [data-widget=AemCspsMillionChild] .inlet-wrapp .csas-calc-white-section {\n    text-align: center;\n  }\n}", ""]);

// exports
